import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import LotusIcon from './LotusIcon';
import { IMAGES } from '../mock';

export default function PageHero({ eyebrow, title, highlight, subtitle, crumbs = [], bg }) {
  return (
    <section className="relative overflow-hidden" style={{ background: bg || 'linear-gradient(180deg, var(--cream) 0%, var(--warm-white) 100%)' }}>
      <div className="absolute -top-16 -right-20 opacity-20"><LotusIcon className="w-80 h-80 animate-float" /></div>
      <div className="absolute -bottom-24 -left-24 w-96 h-96 rounded-full" style={{ background: 'radial-gradient(circle, rgba(232,165,169,0.22), transparent 70%)' }} />

      <div className="relative max-w-6xl mx-auto px-6 md:px-10 py-10 md:py-14">
        {crumbs.length > 0 && (
          <nav aria-label="Breadcrumb" className="text-sm text-[color:var(--taupe-gray)] flex flex-wrap items-center gap-1.5 mb-4">
            {crumbs.map((c, i) => (
              <React.Fragment key={i}>
                {c.to ? <Link to={c.to} className="hover:text-[color:var(--dusty-rose)]">{c.label}</Link> : <span className="text-[color:var(--deep-sage)]">{c.label}</span>}
                {i < crumbs.length - 1 && <ChevronRight className="w-3.5 h-3.5" />}
              </React.Fragment>
            ))}
          </nav>
        )}
        {eyebrow && <div className="eyebrow mb-3">{eyebrow}</div>}
        <h1 className="font-serif-display text-4xl md:text-6xl leading-[1.05] text-[color:var(--deep-sage)] max-w-3xl">
          {title} {highlight && <span className="text-[color:var(--dusty-rose)]">{highlight}</span>}
        </h1>
        {subtitle && <p className="mt-5 text-[color:var(--taupe-gray)] text-lg max-w-2xl leading-relaxed">{subtitle}</p>}
      </div>
    </section>
  );
}
